const month = {
  "01": "January",
  "02": "February",
  "03": "March",
  "04": "April",
  "05": "May",
  "06": "June",
  "07": "July",
  "08": "August",
  "09": "September",
  "10": "October",
  "11": "November",
  "12": "December"

}

export const getDate = (deadline) => {
  const deadlineArray = deadline.split("-");
  return {
    day: deadlineArray[2],
    month: month[deadlineArray[1]]
  }
}